import NextLink from "@casino/legacy/client/shared/NextLink";
import { cn } from "@workspace/frontend-ui";

const LogoLink: FC<{ href: string; className?: string }> = ({
  children,
  className,
  href,
}) => (
  <NextLink
    className={cn("self-center text-foreground", className)}
    href={href}
  >
    {children}
  </NextLink>
);

export default LogoLink;
